/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Lot_Code_Auto_HintInputs */

const vi_tea_lot_code_auto_hint = /** @type {(inputs: Tea_Lot_Code_Auto_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tự sinh khi lưu`)
};

/**

* @param {Tea_Lot_Code_Auto_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_lot_code_auto_hint = /** @type {((inputs?: Tea_Lot_Code_Auto_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Lot_Code_Auto_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_lot_code_auto_hint(inputs)
});